// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"BuildControls_BuildControls__3Gqol","OrderButton":"BuildControls_OrderButton__1T3ad","enable":"BuildControls_enable__3xmhJ"};